import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { routes } from './app.routes';
import { AUTH_INTERCEPTOR_PROVIDER } from './core/interceptors/auth.interceptor';
import { AccessControlService, SessionRefreshService } from './core/services';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    AUTH_INTERCEPTOR_PROVIDER,
    {
      provide: APP_INITIALIZER,
      useFactory: (access: AccessControlService) => () =>
        firstValueFrom(access.ensureLoaded().pipe(catchError(() => of([])))),
      deps: [AccessControlService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (sessionRefresh: SessionRefreshService) => () => {
        sessionRefresh.start();
      },
      deps: [SessionRefreshService],
      multi: true
    }
  ]
};
